import { render, staticRenderFns } from "./Navigate.vue?vue&type=template&id=4a03cc68&scoped=true&"
import script from "./Navigate.vue?vue&type=script&lang=js&"
export * from "./Navigate.vue?vue&type=script&lang=js&"
import style0 from "./Navigate.vue?vue&type=style&index=0&id=4a03cc68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03cc68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSpacer})
